import { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import AppLayout from "../AppLayout";
import { API } from "../apiConfig";

function PrintSettings() {
  const [form, setForm] = useState({
    paper_size: "A5",
    thermal_width: "80",
    show_logo: true,
    show_gst: true,
    show_bank_details: false,
    footer_text: "",
  });

  useEffect(() => {
    loadSettings();
  }, []);

  const authHeader = () => ({
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem("token") || ""}`,
    },
  });

  const loadSettings = async () => {
    try {
      const res = await axios.get(
        `${API}/print-settings`,
        authHeader()
      );

      if (res.data.success) {
        const data = res.data.data;

        setForm({
          paper_size: data.paper_size || "A5",
          thermal_width: data.thermal_width || "80",
          show_logo: Boolean(data.show_logo),
          show_gst: Boolean(data.show_gst),
          show_bank_details: Boolean(data.show_bank_details),
          footer_text: data.footer_text || "",
        });
      }
    } catch {
      Swal.fire("Error", "Unable to load settings", "error");
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const saveSettings = async () => {
    try {
      await axios.post(
        `${API}/print-settings`,
        form,
        authHeader()
      );

      Swal.fire(
        "Saved",
        "Print settings saved successfully",
        "success"
      );
    } catch {
      Swal.fire(
        "Error",
        "Unable to save settings",
        "error"
      );
    }
  };

  return (
    <AppLayout
      title="Print Settings"
      subtitle="Configure invoice print layout"
    >
      <div className="print-settings-card">

        <div className="ps-section">
          <h3>Paper Size</h3>

          <label>
            <input
              type="radio"
              name="paper_size"
              value="A4"
              checked={form.paper_size === "A4"}
              onChange={handleChange}
            />
            A4
          </label>

          <label>
            <input
              type="radio"
              name="paper_size"
              value="A5"
              checked={form.paper_size === "A5"}
              onChange={handleChange}
            />
            A5
          </label>

          <label>
            <input
              type="radio"
              name="paper_size"
              value="THERMAL"
              checked={form.paper_size === "THERMAL"}
              onChange={handleChange}
            />
            Thermal
          </label>
        </div>

        {form.paper_size === "THERMAL" && (
          <div className="ps-section">
            <h3>Thermal Width</h3>

            <select
              name="thermal_width"
              value={form.thermal_width}
              onChange={handleChange}
            >
              <option value="58">58 mm</option>
              <option value="80">80 mm</option>
            </select>
          </div>
        )}

        <div className="ps-section">
          <h3>Print Options</h3>

          <label>
            <input
              type="checkbox"
              name="show_logo"
              checked={form.show_logo}
              onChange={handleChange}
            />
            Show Logo
          </label>

          <label>
            <input
              type="checkbox"
              name="show_gst"
              checked={form.show_gst}
              onChange={handleChange}
            />
            Show GST Number
          </label>

          <label>
            <input
              type="checkbox"
              name="show_bank_details"
              checked={form.show_bank_details}
              onChange={handleChange}
            />
            Show Bank Details
          </label>
        </div>

        <div className="ps-section">
          <h3>Footer Message</h3>

          <textarea
            rows="4"
            name="footer_text"
            value={form.footer_text}
            onChange={handleChange}
            placeholder="Thank you for shopping with us"
          />
        </div>

        <button
          className="ps-save-btn"
          onClick={saveSettings}
        >
          Save Settings
        </button>

      </div>
    </AppLayout>
  );
}

export default PrintSettings;